module.exports = {
  NODE_ENV: "test",
  hostURL: "https://cdn.testidaas.shopspade.com/",
  workorderWebEntry: "https://testworkorder.shopspade.com/",
  shopApi: "https://testshop.shopspade.com/api",
};
